import React, { useContext } from 'react'
import { Column } from 'primereact/column/column.cjs.js'
import { LoadingContext } from '../M_Utils'

export const M_Column = ({ header, body, id, key, field, dataType, onDrop, onDragEnter, className, style, columnKey, color, secondColor, bodyStyle }) => {
    const ctx = useContext(LoadingContext)

    color = color || ctx.primaryColor || "var(--color-black)"
    secondColor = secondColor || ctx.secondaryColor || "var(--color-black)"

    return (
        <Column
            id={id}
            key={key}
            dataType={dataType}
            field={field}
            header={header}
            body={body ? body : null}
            // className={className}
            columnKey={columnKey}
            style={style}
            onDrop={onDrop}
            onDragEnter={onDragEnter}
            headerStyle={{
                borderBottom: `2px solid ${color}`,
                color: secondColor
            }}
            bodyStyle={bodyStyle}
        />
    )
}